var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYesNoBoxed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24919 1.13963C2.42821 1.13963 0.952006 2.61583 0.952006 4.43681V22.07C0.952006 23.891 2.4282 25.3672 4.24919 25.3672H22.0693C23.8903 25.3672 25.3665 23.891 25.3665 22.07V4.43681C25.3665 2.61583 23.8903 1.13963 22.0693 1.13963H4.24919Z",
    fill: "#FAFAFA",
    stroke: "#D0D8DC",
    strokeWidth: 0.732708
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7236 5.40135C11.7614 5.40133 10.8086 5.59084 9.91962 5.95905C9.03066 6.32726 8.22294 6.86695 7.54257 7.54733C6.16849 8.9214 5.39656 10.7851 5.39659 12.7283C5.39662 14.6716 6.1686 16.5353 7.54271 17.9094C8.22311 18.5898 9.03085 19.1295 9.91981 19.4977C10.8088 19.866 11.7616 20.0555 12.7238 20.0555C14.667 20.0555 16.5307 19.2836 17.9048 17.9095C19.2788 16.5354 20.0508 14.6718 20.0507 12.7285C20.0507 11.7663 19.8612 10.8135 19.493 9.92457C19.1247 9.0356 18.585 8.22786 17.9046 7.54747C17.2242 6.86708 16.4165 6.32736 15.5275 5.95913C14.6386 5.59089 13.6858 5.40136 12.7236 5.40135ZM12.7236 6.86676C14.2782 6.86678 15.7691 7.48437 16.8684 8.58366C17.9677 9.68295 18.5853 11.1739 18.5853 12.7285C18.5854 14.2831 17.9678 15.774 16.8685 16.8733C15.7693 17.9726 14.2784 18.5901 12.7238 18.5901L12.7236 6.86676Z",
    fill: "#7E898F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6817,
    height: 23.4949,
    fill: "white",
    transform: "matrix(0.999951 -0.00991711 0.0101446 0.999949 1 1.23572)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6817,
    height: 23.4949,
    fill: "white",
    transform: "matrix(0.999951 -0.00991711 0.0101446 0.999949 1 1.23572)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesNoBoxed);
export default __webpack_public_path__ + "static/media/YesNoBoxed.d8e7971d1611fdaa32963b94c23e96ea.svg";
export { ForwardRef as ReactComponent };